import { WizardHelpNote, WizardStepHeader } from '../wizard';
import pt from '../../locales/pt';
import { formatEUR } from '../../utils/money';

export function EmergencyFundExpensesStep({ value, onChange, prefillAvg }) {
  const copy = pt.emergencyFund.wizard.expenses;
  const showPrefill = prefillAvg > 0;

  return (
    <div className="flex flex-col gap-4">
      <WizardStepHeader
        eyebrow={copy.eyebrow}
        title={copy.title}
        subtitle={copy.hint}
      />

      <label className="flex h-[60px] items-center rounded-[14px] border-[1.5px] border-border bg-card px-4">
        <input
          type="text"
          inputMode="decimal"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="min-w-0 flex-1 border-0 bg-transparent font-display text-[27px] font-bold text-foreground shadow-none outline-none focus:ring-0"
          aria-label={copy.title}
        />
        <span className="ml-auto text-sm font-semibold text-muted-foreground">{copy.currencySuffix}</span>
      </label>

      {showPrefill ? (
        <WizardHelpNote>
          {copy.prefill.replace('{amount}', formatEUR(prefillAvg))}
        </WizardHelpNote>
      ) : null}
    </div>
  );
}

export default EmergencyFundExpensesStep;
